// @ts-ignore
 
import request from "src/lib/axios";

/** 分页查询商品列表 GET /api/v1/products */
export async function ProductControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputProductDtoArray>("/api/v1/products", {
    method: "GET",
    params: {
      // pageSize has a default value: 10
      pageSize: "10",

      // logicOperator has a default value: and
      logicOperator: "and",

      // sortOrder has a default value: DESC
      sortOrder: "DESC",

      ...params,
    },
    ...(options || {}),
  });
}

/** 创建商品 POST /api/v1/products */
export async function ProductControllerCreateV1(
  body: MyApi.CreateProductDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputProductDto>("/api/v1/products", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询商品详情（含 SPU/SKU/分期套餐） GET /api/v1/products/${param0} */
export async function ProductControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputProductDetailDto>(
    `/api/v1/products/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新商品 PUT /api/v1/products/${param0} */
export async function ProductControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductControllerUpdateV1Params,
  body: MyApi.UpdateProductDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputProductDto>(
    `/api/v1/products/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除商品（软删除，级联删除 SPU/SKU/分期套餐） DELETE /api/v1/products/${param0} */
export async function ProductControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(`/api/v1/products/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 批量删除商品（软删除） DELETE /api/v1/products/batch */
export async function ProductControllerBatchRemoveV1(
  body: MyApi.BatchDeleteProductDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>("/api/v1/products/batch", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
